export default defineNuxtPlugin(() => {
  // Плагин для оптимизации изображений и lazy loading
  if (process.client) {
    // Intersection Observer для lazy loading
    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target as HTMLImageElement
          if (img.dataset.src) {
            img.src = img.dataset.src
            img.removeAttribute('data-src')
            imageObserver.unobserve(img)
          }
        }
      })
    }, {
      rootMargin: '50px 0px',
      threshold: 0.01
    })
    
    // Обработка изображений при загрузке страницы
    const processImages = () => {
      const images = document.querySelectorAll('img[data-src]')
      images.forEach(img => {
        imageObserver.observe(img)
      })
    }
    
    // Запускаем при загрузке
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', processImages)
    } else {
      processImages()
    }
    
    // Обрабатываем новые изображения при изменениях DOM
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const element = node as Element
            const images = element.querySelectorAll('img[data-src]')
            images.forEach(img => imageObserver.observe(img))
          }
        })
      })
    })
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    })
    
    // Оптимизация загрузки критических изображений
    const criticalImages = document.querySelectorAll('img[data-critical="true"]')
    criticalImages.forEach(img => {
      if (img.dataset.src) {
        img.src = img.dataset.src
        img.removeAttribute('data-src')
      }
    })
  }
})
